export default __webpack_public_path__ + "static/media/TitilliumWeb-SemiBoldItalic.62b176d8.ttf";